<template>

        <section class="w-100 h-100">

            <!-- Loading -->
            <loading/>

            <h1>Navigation Menu <span v-if="formaction === 'update'" class="update-title" id="update-title"></span></h1>

            <!-- Back To -->
            <template v-if="formaction === 'update'">
                <back-to
                    :urlreference="moduledefaultindex" 
                />
            </template>

            <!-- Form Structure -->
            <div class="d-flex flex-column">

                <form @submit.prevent="sendData('update', 'navmenulistcontent')" action="" class="form-nav" method="post" aria-describedby="Create Nav Menu" enctype="application/x-www-form-urlencoded" autocomplete="on">

                    <!--
                    <fieldset v-if="formaction === 'insert'" class="navmenufieldset mb-3">

                        <header class="d-flex flex-row justify-content-between">
    
                            <div class="legendbase order-1">
                                <legend>Create Menu</legend>
                                <small>Create the menu to list the route</small>
                            </div>
    
                            <div class="baseaction order-2">
                                <button type="button" class="btn btn-dark btncreatemenu" @click="showFieldsetContent($event)">Show</button>
                            </div>
                            
                        </header>
        
                        <div class="fieldsetcontent d-none">
                            <div class="my-2 navmenu">
        
                                <div id="navmenubase-name" class="mb-3 navmenu navmenu-name" data-inputorder="1">
                                    <label for="navmenu-name" class="form-label order-1">Name</label>
                                    <div class="d-flex flex-row order-2">
                                        <input @focusin="inputValidation($event, 'navmenubase-name')" @focusout="inputValidation($event, 'navmenubase-name')" type="text" maxlength="100" name="navmenu-name" v-model="navmenuname" class="form-control" id="navmenu-name" placeholder="Please inform the Name">
                                        <button @click="sendData('insert', 'navmenulist', navmenuname, 'navmenubase-name')" type="button" class="btn btn-primary">Create</button>
                                    </div>
                                </div>
            
                            </div>
                        </div>
        
                    </fieldset>-->

                    <fieldset class="navmenulist">

                        <header v-if="formaction === 'insert'" class="d-flex flex-row justify-content-between">
    
                            <div class="legendbase order-1">
                                <legend>Create the Menu List</legend>
                                <small>Indicate all pages by Menu</small>
                            </div>
    
                            <div class="baseaction order-2">
                                <button type="button" class="btn btn-dark btnmenulist" @click="showFieldsetContent($event)">Show</button>
                            </div>
                            
                        </header>
        
                        <div :class=" formaction === 'update' ? '' : 'd-none'" class="fieldsetcontent fieldsetcontentmenulist">

                            <div v-if="Object.values(menunamelist).length > 0" class="d-flex flex-row my-2 navmenulist col-12 p-0 m-0" style="flex-wrap:wrap;">
        
                                <!-- Menu List -->
                                <div v-for="(value, index) in menunamelist" 
                                :key="value.id" 
                                :data-menuid="value.id" 
                                :class="`d-flex flex-column menulist col-3 p-0 menu-${value.id}`"
                                style="margin-right: 1rem;"
                                >

                                    <span class="order-1" style="border-bottom: .1rem solid #333;">{{ value.name.toUpperCase() }}</span>

                                    <ul 
                                        :class="`list-group order-2 my-1 w-100 navmenu navmenu-${value.name.toLowerCase()}`"
                                        :id="`navmenu-${value.name.toLowerCase()}`" 
                                        :data-menulistid="value.id" 
                                        style="background:#e8e8e8; min-height:2rem;"
                                        @dragover.prevent
                                        @drop="dragFinish($event)"
                                        :ref="`navmenu-${value.name.toLowerCase()}`"
                                        @click="removeMenuItem($event, `navmenu-${value.name.toLowerCase()}`)"
                                    >
                                    </ul>

                                </div>

                                <!-- Pages List -->
                                <div v-if="Object.values(pageslist).length > 0"  class="d-flex flex-column w-100">

                                    <div class="d-flex flex-row justify-content-between order-1">
                                        <p class="my-3 order-1"><strong>Active page list</strong></p>
                                        <button 
                                            class="btn btn-secondary order-2" 
                                            @click="addDropdDown(
                                                dropdowncount, 
                                                'dropdwonlistbase',
                                                '',
                                                '',
                                                'Inform Name',
                                                true
                                                )" 
                                            type="button" 
                                            style="height:2.5rem;"
                                        >Dropdown Page</button>
                                    </div>
                                    
                                    <!-- Active Page List -->
                                    <ul 
                                        class="list-group list-group-horizontal col-12 p-0 m-0 order-2 draglistpages" 
                                        style="flex-wrap:wrap;"
                                    >

                                        <li v-for="(value, index) in pageslist" 
                                            :key="value.id" 
                                            :data-pageid="value.id"
                                            :data-slug="value.slug"  
                                            :id="`page-${value.id}`"
                                            :class="`list-group-item col-2 mt-2 p-2 pages page-${value.id}`"
                                            style="margin-right: 1rem;border: .1rem solid #999;text-align: center;height:2.5rem;"
                                            draggable="true"
                                            @dragstart="dragStart($event)"
                                            @dragenter="dragEnter($event)" 
                                            @dragleave="dragLeave($event)" 
                                            @dragend="dragEnd($event)"
                                        >

                                            {{ value.title }}

                                        </li>

                                    </ul>

                                    <!-- Dropdown Page List -->
                                    <div class="d-flex flex-column order-3">

                                        <p class="my-3 order-1"><strong>Dropdown page list</strong></p>

                                        <ul 
                                            class="list-group list-group-horizontal col-12 p-0 m-0 order-2 draglistpages dropdwonlistbase" 
                                            style="flex-wrap:wrap;"
                                            @dragover.prevent
                                            @drop="dragDropdownFinish($event)"
                                            @dragstart="dragStartDropdownList($event)"
                                            @click="removeMenuItem($event, 'dropdownlist')"
                                        ></ul>

                                    </div>
                                
                                </div>

                                <span v-else>Please is necessary create the pages</span>
            
                            </div>

                            <div v-else>

                                <span>Please create the menu</span>

                            </div>

                        </div>

                    </fieldset>

                    <button type="submit" class="btn btn-primary float-end my-3" :disabled="disabled">{{ btntext }}</button>

                </form>

            </div>

             <!-- Nav Menu List -->
            <div v-if="formaction === 'insert'" class="d-flex flex-column w-100 h-100">

                <h2 class="order-1">Menu List</h2>

                <!-- Check Menu List -->
                <template v-if="Object.values(alldata).length > 0">

                    <!-- Page List Render-->
                    <table-element :classname="['table-striped', 'order-2', 'my-3']">

                        <!-- THead -->
                        <template #thead>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">User Created</th>
                                <th scope="col">Name</th>
                                <th scope="col">Pages</th>
                                <th scope="col">Dropdown</th>
                                <!-- <th scope="col">Active</th> -->
                                <th scope="col">Created</th>
                                <th scope="col">Updated</th>
                                <!-- <th scope="col">SoftDelete</th> -->
                                <th scope="col">Actions</th>
                            </tr>
                        </template>

                        <!-- Tbody -->
                        <template #tbody>

                            <tr v-for="(value, index) in alldata" :key="value.id" :data-referid="index" :data-menuid="value.id" :data-userid="value.user_id">
                                <th scope="row">{{ value.id }}</th>
                                <td>{{ value.user_name }}</td>
                                <td>{{ value.navmenuname }}</td>
                                <td>{{ getPagesRelated(value.pages, false) }}</td>
                                <td>{{ getPagesRelated(value.pages, true) }}</td>
                                <!-- <td>
                                    <button @click="buttonsAction($event, 'active')" class="btn btn-light" type="button" data-action="1">
                                        {{ value.active }}
                                    </button>
                                </td> -->
                                <td>{{ value.created_at }}</td>
                                <td>{{ value.updated_at !== null ? value.updated_at : '' }}</td>
                                <td>{{ value.deleted_at !== null ? value.deleted_at : '' }}</td>
                                <td class="d-flex flex-row justify-content-between">
                                    <button class="btn btn-primary" @click="buttonsAction($event, 'edit')" data-action="2">Edit</button>
                                    
                                    <!---
                                    <template v-if="value.deleted_at === null">
                                        <button class="btn btn-danger" type="button" @click="buttonsAction($event, 'softdelete')" data-action="3">Delete</button>
                                    </template>
                                    
                                    <template v-else>
                                        <button class="btn btn-info" type="button" @click="buttonsAction($event, 'restore')" data-action="4">Restore</button>
                                    </template>-->
                                    
                                    <!---<div v-if="parseInt(value.user_rule) === 1">
                                        <button class="btn btn-danger" type="button" @click="buttonsAction($event, 'remove')" data-action="5">Remove</button>
                                    </div>-->

                                </td>
                            </tr>

                        </template>

                    </table-element>

                </template>

                <template v-else>

                    <span>Please create NavMenu</span>
    
                </template>
            
            </div>

             <!-- Response Messages -->
            <div class="order-3 responsebasemessage" ref="responsebasemessage">

                <list-message/>

            </div>

        </section>

</template>
<script>

import fetchData from './../../fetchData.js';
import htmlElements from './../../htmlElements.js';
import validation from './../../inputValidation.js';
import ListMessage from './../elements/ListMessageElement.vue';
import Loading from './../elements/LoadingElement.vue';
import Table from './../elements/TableElement.vue';
import BackTo from './../elements/BackToElement.vue';

//Set Use Strict
"use strict";

    export default{
        name: "NavCompoment",
        props:{

            csrftolken:{
                type: String,
                required: true
            },
            allpageslist:{
                type: String,
                required: true
            },
            navmenulist:{
                type: String,
                required: true
            },
            navmenucreate:{
                type: String,
                required: true
            },
            navmenuupdate:{
                type: String,
                required: true
            },
            formactionroute:{
                type: String,
                required: true
            },
            navmenupagelist:{
                type: String,
                required: true
            },
            navmenuactive:{
                type: String,
                required: true
            },
            navmenurestore:{
                type: String,
                required: true
            },
            navmenusoftdelete:{
                type: String,
                required: true
            },
            navmenudelete:{
                type: String,
                required: true
            },
            baseurl:{
                type: String,
                required: true
            },
            moduledefaultindex:{
                type: String,
                required: true
            }

        },
        data: () => {

            return{

                disabled: false,
                activeclass: 'd-flex',
                btntext: 'Update',
                dropdowncount: 1,
                pageitemelement: "",
                alldata: {},
                pageslist: {},
                menunamelist: {},
                menudropdown: [],
                navmenuname: "",
                listidinputs: [],
                formaction: "",
                buttonsaction: {},
                redirectediturl: "",
                singlenavmenu: {}

            }

        },
        created(){

            //Set FormAction Route
            this.formaction = this.formactionroute;

            //Set Pages List
            this.pageslist = JSON.parse(this.allpageslist);

            //Filter Pages get only Avtive Pages
            this.pageslist = this.pageslist.filter( value => parseInt(value.active) === 1);

            //Set navMenuList
            this.menunamelist = JSON.parse(this.navmenulist);

            //console.log(this.menunamelist);

            //Set List for Menu
            this.addMenuPagesList();

            //Set NavMenuList
            this.alldata = JSON.parse(this.navmenupagelist);

            //console.log(this.alldata);

        },
        mounted(){

            //Check FormAction for Update Routine
            if(this.formaction === 'update'){

                //Set Single NavMenu Data
                this.singlenavmenu = JSON.parse(this.navmenupagelist);

                //console.log(this.singlenavmenu);

                //Set First Name in the to Uppercase
                let firstletter = this.singlenavmenu[0].navmenuname.at(0).toUpperCase();
                let newNavName = this.singlenavmenu[0].navmenuname.replace(this.singlenavmenu[0].navmenuname.at(0), firstletter);

                //Set NavMenu Name
                document.querySelector('.update-title').textContent = newNavName;

                //Get All Menu List
                let navmenulist = [...document.querySelectorAll('ul.navmenu')];

                //console.log(navmenulist);

                //Get NavMenu by id
                let navmenu = navmenulist.find(value => parseInt(value.getAttribute('data-menulistid')) === parseInt(this.singlenavmenu[0].id));

                //Get Id from navmenu
                let navmenuid = navmenu.getAttribute('id');

                //Get No Dropdown List
                let noDropdownList = [];

                //Get Dropdown List
                let dropdownList = [];

                //Set NavMenu Items
                this.singlenavmenu.forEach((value) => {

                    //Clean Data
                    let pages = JSON.parse(value.pages);

                    //Set NoDropdown List and Dropdown List
                    noDropdownList = pages.filter(valpageitemtype => !Array.isArray(valpageitemtype));
                    dropdownList = pages.filter(valpageitemtype => Array.isArray(valpageitemtype));        

                });

                //----> Render Elements

                //console.log(noDropdownList);
                //console.log(dropdownList);

                //Check NoDropdown List and Add in List
                if(noDropdownList.length > 0){

                    noDropdownList.forEach(page => {

                        //Create Element LI
                        let elementitem = htmlElements.createElement('li',  {
                            class: `list-group-item`,
                            data_pageid: `${page.id}`,
                        }, `${page.name}`);

                        //Append Child LI
                        document.getElementById(`${navmenuid}`).appendChild(elementitem);

                    });

                }

                //Check Dropdown List and Add in List
                if(dropdownList.length > 0){

                    //console.log(dropdownList);

                    dropdownList.forEach(dropdowpageslist => {

                        //console.log(dropdowpageslist);

                        dropdowpageslist.forEach(valitemdropdown => {

                            //console.log(valitemdropdown);

                            //List All already liitems 
                            let listAllPages = [...document.getElementById(`${navmenuid}`).children];

                            //Create Element LI
                            let elementnavmenuitem = htmlElements.createElement('li',  {
                                class: `list-group-item`,
                                data_pageid: `${valitemdropdown.pageidrefer}`,
                            }, `${valitemdropdown.dropdownname}`);

                            //Get List of PageName Already add in the list
                            let alreadyAddPagename = [];

                            //Check Value from Li list item
                            listAllPages.forEach(valitepage => {

                                //Set Pagename
                                alreadyAddPagename.push(valitepage.textContent);

                            });

                            //Set Dropdown Item List
                            if(listAllPages.length === 0){

                                //Append Child LI
                                document.getElementById(`${navmenuid}`).appendChild(elementnavmenuitem);

                            }else{

                                //Check DropdoownName in the Already Page List
                                if(!alreadyAddPagename.includes(valitemdropdown.dropdownname)){

                                    //Append Child LI
                                    document.getElementById(`${navmenuid}`).appendChild(elementnavmenuitem);

                                }

                            }

                            //console.log(valitemdropdown);

                            //===> Create Dynamic Dropdownlistbase

                            //Get Children from DropdownList Base
                            let dropdownlisbase = [...document.querySelector('.dropdwonlistbase').children];

                            //Get List of PageName Already add in the list
                            let alreadyAddPagenameInDropdownList = [];

                            //Check Value from Li list item
                            dropdownlisbase.forEach(valitepage => {

                                //Set Pagename
                                alreadyAddPagenameInDropdownList.push(valitepage.firstChild.textContent);

                            });

                            //Set New Value for dropdowncount
                            this.dropdowncount = parseInt(valitemdropdown.pageidrefer.replace('dropdownitem-', ''));

                            //Check Dropdownlistbase
                            if(dropdownlisbase.length === 0){

                                //Set Dropdown li list
                                this.addDropdDown(
                                    this.dropdowncount, 
                                    'dropdwonlistbase', 
                                    valitemdropdown.dropdownid, 
                                    valitemdropdown.pageidrefer,
                                    valitemdropdown.dropdownname
                                );

                            }else{

                                //console.log(dropdownlisbase);
                                //console.log(alreadyAddPagenameInDropdownList);

                                //Check 
                                if(!alreadyAddPagenameInDropdownList.includes(valitemdropdown.dropdownname)){

                                   //Set Dropdown li list
                                    this.addDropdDown(
                                        this.dropdowncount, 
                                        'dropdwonlistbase', 
                                        valitemdropdown.dropdownid, 
                                        valitemdropdown.pageidrefer,
                                        valitemdropdown.dropdownname
                                    );

                                }

                            }

                            //Create Element LI
                            let elementitem = htmlElements.createElement('li',  {
                                class: `list-group-item`,
                                data_pageid: `${valitemdropdown.pageid}`,
                                data_slug: `${valitemdropdown.slug}`,
                            }, `${valitemdropdown.name}`);

                            //Append Child LI
                            document.getElementById(`${valitemdropdown.dropdownid}`).appendChild(elementitem);

                            //Push Valdropdownitem
                            this.menudropdown.push(valitemdropdown);

                        });

                    });

                }

                /* console.log(noDropdownList);
                console.log(dropdownList); */

                //Show FieldsecontentMenuList
                document.querySelector('.fieldsetcontentmenulist').classList.remove('d-none');

                //Add Pages data from singlenavmenu
                this.menunamelist.map((value) => {

                    //Change Current Pages
                    if(parseInt(value.id) === parseInt(this.singlenavmenu[0].id)){

                        value.pages = JSON.parse(this.singlenavmenu[0].pages);

                        return value;

                    }

                });

                //Remove Other Navmanu
                navmenulist.forEach((value) => {
                    
                    //Remove Elements
                    if(value.getAttribute('id') !== navmenuid){

                        //Get Parent Element
                        let parentEl = value.parentElement;

                        parentEl.remove();

                    }

                });

            }

        },
        methods:{

            getPagesRelated(menulist, getonlydropdowndata){

                //Parse Data
                let menu = JSON.parse(menulist);

                //Check Menulist
                if(menu === null || menu === undefined){

                    return;

                }

                //console.log(menu);

                //Get Pages Related by menu
                let menupages = menu.filter((valmenuitem) => {

                    /* console.log(getonlydropdowndata);
                    console.log(valmenuitem); */

                    //Get specific MenuPage Data - Dropdpown
                    if(getonlydropdowndata === true && Array.isArray(valmenuitem)){

                        return valmenuitem;

                    }else{

                        //Get specific MenuPage Data - Only Pages
                        if(getonlydropdowndata === false && !valmenuitem.hasOwnProperty('dropdownid')){

                            return valmenuitem;

                        }

                        //Get specific MenuPage Data - Dropdpown
                        if(getonlydropdowndata === true && valmenuitem.hasOwnProperty('dropdownid')){

                            console.log(valmenuitem);

                            return valmenuitem;

                        }


                    }

                });

                //console.log(menupages);

                //Get Pages
                if(menupages.length > 0 && !getonlydropdowndata){

                    //Pages
                    let pagename = "";

                    //Set Page Names for show on List
                    menupages.reduce((index, value) => {

                        for(const [indexobjc, valueobj] of Object.entries(value)){

                            if(indexobjc === 'name'){

                                pagename += `${valueobj} > `;

                            }

                        }

                        return pagename;

                    }, 0);

                    return pagename;

                }

                //Get Dropdown Pages
                if(menupages.length > 0 && getonlydropdowndata){

                    //console.log(menupages);

                    //Dropdown Menu Name
                    let dropdownname = [];

                    //Pages
                    let pagename = [];

                    //Set Pages names
                    menupages.forEach((valmenuitem) => {

                        //Check Type of data
                        if(Array.isArray(valmenuitem)){

                            //console.log(valmenuitem);

                            //Set Dropdownname
                            valmenuitem.forEach((valdropdown, indexdropdown) => {

                                dropdownname.push(valdropdown.dropdownname);
                    
                            });
                            
                            pagename.push(valmenuitem);
                            
                        }else{

                            //Set only dropdown name
                            dropdownname.push(valmenuitem.dropdownname);

                            //Set only pages name
                            pagename.push(valmenuitem.name);

                        }

                    });

                    //Set Unique DropdownNames
                    let uniquedropdpwnname = [...new Set(dropdownname)];

                   /*  console.log(uniquedropdpwnname);
                    console.log(pagename); */

                    //Dropdown Menu List
                    let dropdownmenulist = [];

                    //Set Dropdown Pages Name
                    let dropdownpages = [];

                    //console.log(uniquedropdpwnname);

                    //Get Data from Dropdwon Page Name
                    pagename.forEach((valdropdownitem, indexdropdownitem) => {

                        if(Array.isArray(valdropdownitem) && valdropdownitem.length > 0){

                            //Get All Pagename by dropdown
                            let pagenamerefer = [];

                            valdropdownitem.forEach((valpages, indexpage) => {

                                let indeDropdownName = uniquedropdpwnname.indexOf(valpages.dropdownname);

                                //Set Pagename by Dropdown List
                                if(valpages.dropdownname === uniquedropdpwnname[indeDropdownName]){

                                    pagenamerefer.push(valpages.name); 

                                }
                                
                            });

                            //Push Pagename per Dropdown
                            dropdownpages.push(pagenamerefer); 

                        }

                    });

                    //console.log(dropdownpages);

                    //Set Dropdown Menu List
                    uniquedropdpwnname.forEach((value, index) => {

                        //Dropdown Menu List Item
                        let dropdownmenulistitem = value + " => " + dropdownpages[index].join(" > ");

                        //List with all Dropdown menu
                        dropdownmenulist.push(dropdownmenulistitem);

                    });

                    return dropdownmenulist.join(", ");

                }

                return;
               

            },
            buttonsAction(element, action){

                //Get Index from Page List
                let parentReferId = action === 'remove' ? 
                element.currentTarget.parentElement.parentElement.parentElement.getAttribute('data-referid') : 
                element.currentTarget.parentElement.parentElement.getAttribute('data-referid');

                //Get Values from List
                let currentItem = Object.values(this.alldata).find((value, index) => index === parseInt(parentReferId));

                //Set Formaction
                switch(action)
                {

                    case 'softdelete':
                        this.buttonsaction.formaction = 'softdelete';
                    break;

                    case 'restore':
                        this.buttonsaction.formaction = 'restoresoftdelete';
                    break;

                    case 'edit':
                        
                        this.redirectediturl = this.baseurl + "/admin/website/navigationsingle/menuid=" + currentItem.id;

                    break;

                    case 'remove':
                    case 'active':

                        //Confirm
                        let confirmAction = confirm(`Are you sure do you want to ${action} this page?`);

                        //Confirm Remove Action
                        if(confirmAction){

                            this.buttonsaction.formaction = action === 'remove' ? 'delete' : 'active';

                        }else{

                            return;

                        }
                    
                    break;

                }

                //Redirect for edit
                if(action === 'edit'){

                    window.location.replace(this.redirectediturl);

                    return;


                }

                //Set Page Id
                this.buttonsaction.id = currentItem.id;

                //Set Active Action
                if(action === 'active'){

                    this.buttonsaction.activeaction = element.currentTarget.textContent.trim();

                }

                //Send Data for delete
                return this.sendData(this.buttonsaction.formaction, '', this.buttonsaction);

            },
            addMenuPagesList(){

                //Set List For Menu
                if(this.menunamelist.length > 0){

                    this.menunamelist.map((value) => {

                        return value.pages = [];

                    });

                }

                return;

            },
            showFieldsetContent(element){

                //Get Fieldsetcontent
                let fieldsetcontent = element.currentTarget.parentElement.parentElement.nextElementSibling;

                //Check Class
                if(fieldsetcontent.classList.contains('d-none')){

                    //Remove Class
                    fieldsetcontent.classList.remove('d-none');

                    //Set Text Content
                    element.currentTarget.textContent = 'Hide';

                }else{


                    //Add Class
                    fieldsetcontent.classList.add('d-none');

                    //Set Text Content
                    element.currentTarget.textContent = 'Show';

                }

            },
            inputValidationMethod(validationtype, inputvalue, inputid = ''){

                //Instance Validation
                let inputValidation = new validation(validationtype, '', '');

                //Validation Method
                let validInput;

                //Set Method
                switch(validationtype)
                {
                    //Input Validation only for numbers
                    case 2:
                        validInput = inputValidation.validNameCases(validationtype, inputvalue);
                    
                    break;

                    //Input Validation All Types of data
                    case 4:
                        validInput = inputValidation.validNameCases(validationtype, inputvalue);
                    break;

                    //Email Validation
                    case 7:

                        let emailRegex = new RegExp(/^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/, "gm");
                        validInput = emailRegex.test(inputvalue);
                        
                    break;
                    
                    //URL Validation
                    case 8:
                        validInput = inputValidation.isValidUrl(inputvalue, inputid);
                    break;

                }

                return validInput;

            },
            inputValidation(element, inputid){

                //Check Value
                if(element.currentTarget.value !== ''){

                    //Check by inputid
                    switch(inputid)
                    {

                        //Title, Subtitle
                        case 'navmenu-name':
                        case 'navmenubase-name':           
                            
                            //Check Validation
                            this.disabled = this.inputValidationMethod(4, element.currentTarget.value) === true ? false : true;

                            //Check Error
                            if(this.disabled){

                                //Set Id for Error Generate
                                this.listidinputs.push(inputid)

                                //Generate Error Message
                                this.dynamicErrorMessageGenerate(this.listidinputs);

                                //Clean Variable
                                this.listidinputs = [];

                            }

                        break;

                    }

                    return this.disabled;

                }

                return this.disabled;

            },
            dynamicErrorMessageGenerate(listIdInputs, timeout = 5000){

                //Show Error Messages
                if(listIdInputs.length > 0){

                    //console.log(this.listidinputs);

                    //Set id for error message
                    listIdInputs.forEach((value) => {

                        //Instance Validation
                        let inputValidation = new validation(3, '', '');

                        //Set Uppercase
                        let firstLetter = value.at(0).toUpperCase();
                        let capitalizaValue = value.replace(value.at(0), firstLetter);

                        //Render Erro Message
                        inputValidation.createErrorMessageElement(value, `Please inform the correct format for ${capitalizaValue}`);

                    });

                    //Clean Variable
                    this.listIdInputs = [];

                    //console.log(this.listidinputs);

                    //Clean Error Message
                    setTimeout(function(){

                        //Clean all Error Messages
                        [...document.querySelectorAll('span.errorMessage')].forEach((value) => {

                            //Remove element
                            value.remove();

                        });

                    }, timeout);

                    //Disabled Submit
                    //this.disabled = true;

                    return this.listIdInputs;

                }

            },
            dragFinish(element){

                //Get Current Data from Element
                let item = element.currentTarget;

                //Data From Drag Element
                const dataEl = element.dataTransfer.getData('dataEl');

                //Check Data
                if(dataEl){

                    //Data Element Info
                    let dataElInfoDrag = JSON.parse(dataEl);

                    //console.log(dataElInfoDrag);
                    
                    //Confirm Push for append
                    let confirm = true;

                    //Check Dropdown Item
                    if(!dataElInfoDrag.pageid.includes('dropdownitem') && Number.isInteger(parseInt(dataElInfoDrag.pageid))){

                        //console.log(Number.isInteger(parseInt(dataElInfoDrag.pageid)));

                        //Set Page Id related by Menu
                        this.menunamelist.map((value) => {

                            //Check Menu Id
                            if(parseInt(value.id) === parseInt(item.getAttribute('data-menulistid'))){

                                let pageData = {
                                    id: dataElInfoDrag.pageid,
                                    name: dataElInfoDrag.text.toLowerCase().trim(),
                                    slug: dataElInfoDrag.slug,
                                };

                                //Check Menu Pages List
                                if(value.pages.length === 0){

                                    return value.pages.push(pageData);

                                }else{

                                    let findpage = value.pages.find(valpages => parseInt(valpages.id) === parseInt(dataElInfoDrag.pageid));

                                    //Check Page List For Push
                                    if(findpage === undefined){

                                        return value.pages.push(pageData);

                                    }else{

                                        confirm = false;

                                        return confirm;

                                    }

                                }

                            }

                        });

                    }else{

                        //Check Dropdown List
                        if(this.menudropdown.length > 0){

                            //console.log(dataElInfoDrag);

                            //Get Dropdown Page List
                            let dropdownPageList = this.menudropdown.filter(valpages => valpages.pageidrefer === dataElInfoDrag.pageid);

                            //Set Page Dropdwon List
                            this.menunamelist.map((value) => {

                                if(parseInt(value.id) === parseInt(item.getAttribute('data-menulistid'))){

                                    //Check Type
                                    let dropdownindicate = value.pages.filter(valpages => Array.isArray(valpages));

                                    //Check Type from Pages
                                    if(dropdownindicate.length === 0){

                                        return value.pages.push(dropdownPageList);

                                    }else{

                                        //Check PageidRefer from Dropdown Item
                                        let newpushconfirm = [];

                                        dropdownindicate.forEach((valdropdownitem) => {

                                            //console.log(valdropdownitem);

                                            let pushconfirmvalue = valdropdownitem.find(valitem => valitem.pageidrefer === dataElInfoDrag.pageid);

                                            if(pushconfirmvalue !== undefined){

                                                newpushconfirm.push(pushconfirmvalue);

                                            }

                                        });
                                        
                                        //console.log(dropdownindicate);
                                        //console.log(newpushconfirm);

                                        //Check Confirm for new push
                                        if(newpushconfirm.length === 0){

                                            return value.pages.push(dropdownPageList);

                                        }else{

                                            confirm = false;

                                            return confirm;

                                        }

                                    }
                                    
                                }   

                            });

                        }

                    }

                    //Check Confirm
                    if(confirm){
                    
                        //Create Element
                        let elementitem = htmlElements.createElement(`${dataElInfoDrag.el}`,  {
                            class: `${dataElInfoDrag.class}`,
                            data_pageid: `${dataElInfoDrag.pageid}`
                        }, `${dataElInfoDrag.text}`);

                        //Append Child
                        document.getElementById(item.getAttribute('id')).appendChild(elementitem);

                        //console.log(`DragFinish - ${item}`);
                        //console.log('DragFinish');
                        //console.log(JSON.parse(dataEl));

                        return;

                    }

                    alert("Esta página já foi add ao Menu");

                    return;

                }

                return;
              
            },
            dragStart(element){

                //Get Current Data from Element
                let item = element.currentTarget;

                //Check Element
                if(item.nodeName === "LI"){

                    //Checl Grabbing Class
                    if(item.classList.contains('grabbingaction')){

                        //Add Grabbing Class
                        item.classList.remove('grabbingaction');

                    }

                    //Get Page Id
                    let dataElInfo = {
                    pageid: item.getAttribute('data-pageid'),
                    slug: item.getAttribute('data-slug'),
                    text: item.textContent.trim(),
                    class: "list-group-item",
                    el: item.nodeName.toLowerCase()
                    };

                    //Drag Operation
                    element.dataTransfer.dropEffect = 'move';
                    element.dataTransfer.effectAllowed = 'move';
                    element.dataTransfer.setData('dataEl', JSON.stringify(dataElInfo));

                }

            },
            dragEnter(element){

                //Get Current Data from Element
                let item = element.currentTarget;

                //Add Grabbing Class
                item.classList.add('grabbingaction');

            },
            dragLeave(element){

                //Get Current Data from Element
                let item = element.currentTarget;

                //Add Grabbing Class
                item.classList.add('grabbingaction');

            },
            dragEnd(element){

                //Get Current Data from Element
                let item = element.currentTarget;

                //Add Grabbing Class
                item.classList.remove('grabbingaction');

            },
            addDropdDown(count, appendlist, dropdownid = "", pageidrefer = "", spanname = "Inform Name", countnewvalue = false){

                //Check update route
                if(this.formaction === 'update' && this.menudropdown.length > 0 && countnewvalue){

                    //Set New value for the count
                    count = count + 1;

                }

                //Check PageIdRefer
                let pageIdRefer = pageidrefer === "" ? `dropdownitem-${count}` : `${pageidrefer}`;
                
                //Check DropdwonId
                let dropdownId = dropdownid === "" ? `dropdownlist-${count}` : dropdownid;

                //Create Element LI
                let elementitem = htmlElements.createElement('li',  {
                    class: `list-group-item col-2 mt-2 p-2 pages dropdownitem ${pageIdRefer}`,
                    id: pageIdRefer,
                    data_pageid: pageIdRefer,
                    //contenteditable: "true",
                    draggable: "true",
                    style: "margin-right: 1rem;border: .1rem solid #999;text-align: center;min-height:2.5rem;"
                });

                //Append Child LI
                document.querySelector(`.${appendlist}`).appendChild(elementitem);

                //Create Element SPAN
                let elementtext = htmlElements.createElement('span',  {
                    class: `w-100 p-1 m-1 linameitem linameitem-${count}`,
                    id: `linameitem-${count}`,
                    contenteditable: "true",
                }, `${spanname}`);

                //console.log(elementtext);

                //Append Child SPAN
                document.querySelector(`.${pageIdRefer}`).appendChild(elementtext);

                //Create Element UL
                let elementlist = htmlElements.createElement('ul',  {
                    class: `list-group w-100 mt-2 dropdownlist ${dropdownId}`,
                    id: dropdownId,
                    style: "background-color:#e7e7e7;min-height:1.75rem;",
                    data_pageidrefer: pageIdRefer,
                });

                //Append Child UL
                document.querySelector(`.dropdownitem-${count}`).appendChild(elementlist);

                //Increments Value
                this.dropdowncount++;

            },
            dragDropdownFinish(element){

                //Get Element Data
                let el = element.target;

                //Related Element
                let relatedEl = el.nodeName === 'UL' ? el : el.parentElement;

               //Check Element
               if(relatedEl.nodeName === "UL" && relatedEl.classList.contains("dropdownlist")){

                    //Data From Drag Element
                    const dataEl = element.dataTransfer.getData('dataEl');

                    //Check Data
                    if(dataEl){

                        //Data Element Info
                        let dataElInfoDrag = JSON.parse(dataEl);

                        //Confirm Push for append
                        let confirm = true;

                        //console.log(relatedEl);

                        //Page Data Info
                        let pageData = {
                            dropdownname: relatedEl.previousElementSibling.textContent.trim().toLowerCase(),
                            dropdownid: relatedEl.getAttribute('id'),
                            pageidrefer: relatedEl.getAttribute('data-pageidrefer'),
                            pageid: dataElInfoDrag.pageid,
                            slug: dataElInfoDrag.slug,
                            name: dataElInfoDrag.text.toLowerCase()
                        };

                        //console.log(pageData);

                        //Set Page Id related by Menu
                        if(this.menudropdown.length === 0){

                            //Push Nav Menu Item for Dropdown List
                            this.menudropdown.push(pageData);

                            //Check Update Route
                            if(this.formaction === 'update' && this.menunamelist.length > 0){

                                //Check Item from NavMenu when is a Array - NavMenu List Data to Updated
                                this.menunamelist.map((valitemmenulist) => {

                                    //Check Array Type
                                    if(Array.isArray(valitemmenulist.pages)){

                                        //Check the current Dropdown Item
                                        valitemmenulist.pages.map((valdropdownitem, indexdropdownitem) => {

                                            //Check the Current Dropdown List
                                            if(Array.isArray(valdropdownitem)){

                                                //Check Dropdown Menu Item
                                                valdropdownitem.map((valitemdrop, indexitemdrop) => {

                                                    //Check Dropdown Id List
                                                    if(pageData.dropdownid === valitemdrop.dropdownid 
                                                    && !valdropdownitem.includes(pageData)){

                                                        //Push New Item for Dropdown List
                                                        valdropdownitem.push(pageData);

                                                    }

                                                });

                                            }

                                        });

                                    }

                                });

                            }

                        }else{
              
                            //Check Dropdown menu item
                            let findpage = this.menudropdown.find((valpages) => {

                                if(valpages.dropdownid === relatedEl.getAttribute('id') &&
                                parseInt(valpages.pageid) === parseInt(dataElInfoDrag.pageid)
                                ){

                                    return valpages;

                                }


                            });

                            //Check Page List For Push
                            if(findpage === undefined){

                                //Push Nav Menu Item for Dropdown List
                                this.menudropdown.push(pageData);

                                //Check Update Route
                                if(this.formaction === 'update' && this.menunamelist.length > 0){

                                    //Check Item from NavMenu when is a Array - NavMenu List Data to Updated
                                    this.menunamelist.map((valitemmenulist) => {

                                        //Check Array Type
                                        if(Array.isArray(valitemmenulist.pages)){

                                            //Check the current Dropdown Item
                                            valitemmenulist.pages.map((valdropdownitem, indexdropdownitem) => {

                                                //Check the Current Dropdown List
                                                if(Array.isArray(valdropdownitem)){

                                                    //Check Dropdown Menu Item
                                                    valdropdownitem.map((valitemdrop, indexitemdrop) => {

                                                        //Check Dropdown Id List
                                                        if(pageData.dropdownid === valitemdrop.dropdownid 
                                                        && !valdropdownitem.includes(pageData)){

                                                            //Push New Item for Dropdown List
                                                            valdropdownitem.push(pageData);

                                                        }

                                                    });

                                                }

                                            });

                                        }

                                    });

                                }

                            }else{

                                confirm = false;

                            }

                        }

                        //Check Confirm
                        if(confirm){

                            //Create Element
                            let elementitem = htmlElements.createElement(`${dataElInfoDrag.el}`,  {
                                class: `${dataElInfoDrag.class}`,
                                data_pageid: `${dataElInfoDrag.pageid}`,
                                data_slug: `${dataElInfoDrag.slug}`
                            }, `${dataElInfoDrag.text}`);

                            //Append Child
                            document.getElementById(relatedEl.getAttribute('id')).appendChild(elementitem);

                            return;

                        }

                        alert("Esta página já foi add ao Menu Dropdown");

                        return;

                    }

               }

               return;

            },
            dragStartDropdownList(element){

                //Get Current Data from Element
                let item = element.target;

                //Check Element
                if(item.nodeName === 'LI' && item.classList.contains('dropdownitem')){

                    //Checl Grabbing Class
                    if(item.classList.contains('grabbingaction')){

                        //Add Grabbing Class
                        item.classList.remove('grabbingaction');

                    }

                    //console.log(item);

                    //Get Page Id
                    let dataElInfo = {
                        pageid: item.getAttribute('data-pageid'),
                        slug: item.getAttribute('data-slug'),
                        class: "list-group-item",
                        el: item.nodeName.toLowerCase(),
                        text: item.firstChild.textContent.trim()
                    };

                    //Drag Operation
                    element.dataTransfer.dropEffect = 'move';
                    element.dataTransfer.effectAllowed = 'move';
                    element.dataTransfer.setData('dataEl', JSON.stringify(dataElInfo));

                }
                
                return;

            },
            removeMenuItem(element, list){

                //Get Item
                let item = element.target;

                //Check LI Element
                if(item.nodeName !== 'LI'){

                    return;

                }

                //Check item and NavMenu list conditional
                if(item.nodeName === 'LI' && list.includes('navmenu')){

                    //Get Children from element list
                    let listitems = [...document.querySelector(`.${list}`).children];

                    //Check Childrens
                    if(listitems.length > 0){

                        //Get PageId
                        let pageId = item.getAttribute('data-pageid');

                        //List All Items
                        this.menunamelist.map((value) => {

                            //Check Element
                            if(parseInt(value.id) === parseInt(document.querySelector(`.${list}`).getAttribute('data-menulistid'))){

                                //Check Pages List
                                value.pages.map((valitem, indexitem) => {

                                    //Check Array Type
                                    if(Array.isArray(valitem) && pageId.includes('dropdownitem')){

                                        //Check Dropdown Menu
                                        let confirmList = valitem.find(valdropdownitem => valdropdownitem.pageidrefer === pageId);

                                        //Check confirm Dropdown Menu
                                        if(confirmList !== undefined){

                                            //Remove element from Menu list
                                            value.pages.splice(indexitem, 1);

                                            //Remove element from DOM
                                            item.remove();

                                        }

                                        return;

                                    }

                                    //Check Object
                                    if(!Array.isArray(valitem) && typeof valitem === 'object' && !pageId.includes('dropdownitem')){

                                        //Check element from Menu List
                                        if(parseInt(valitem.id) === parseInt(pageId)){

                                            //Remove element from Menu list
                                            value.pages.splice(indexitem, 1);

                                            //Remove element from DOM
                                            item.remove();

                                        }

                                        return;

                                    }

                                });

                            }

                        });

                    }
                    
                    return;

                }

                //Check item and Dropdownmlist
                if(item.nodeName === 'LI' && list.includes('dropdownlist') && !item.hasAttribute('id')){

                    //Get PageId from current Dropdown menu item
                    let pageId = item.getAttribute('data-pageid');

                    //Get Dropdown Id
                    let dropdownId = item.parentElement.getAttribute('id');

                    //Get Children from Dropdown List
                    let dropdownList = [...item.parentElement.children];

                    //Check dropdown list
                    if(dropdownList.length > 0){

                        //List All Items
                        this.menudropdown.map((valitem, indexitem) => {

                            //Check Params
                            if(parseInt(valitem.pageid) === parseInt(pageId) &&
                            valitem.dropdownid === dropdownId){

                                //Remove from dropdown list
                                this.menudropdown.splice(indexitem, 1);

                                //Check Item from NavMenu when is a Array - NavMenu List Data to Updated
                                this.menunamelist.map((valitemmenulist) => {

                                    //Check Array Type
                                    if(Array.isArray(valitemmenulist.pages)){

                                        //Check the current Dropdown Item
                                        valitemmenulist.pages.map((valdropdownitem, indexdropdownitem) => {

                                            //Check the Current Dropdown List
                                            if(Array.isArray(valdropdownitem)){

                                                valdropdownitem.map((valitemdrop, indexitemdrop) => {

                                                    //Check Dropdown Menu Item
                                                    if(parseInt(valitemdrop.pageid) === parseInt(pageId) &&
                                                    valitemdrop.dropdownid === dropdownId){

                                                        console.log(valitemdrop);

                                                        //Remove from Dropdown Menu
                                                        valdropdownitem.splice(indexitemdrop, 1);

                                                    }

                                                });

                                            }

                                        });

                                    }

                                });

                                //Remove Element
                                item.remove();

                                return;

                            }

                        });

                    }

                    return;
                    
                }

                //Check Dropdownitem
                if(item.getAttribute('id').includes('dropdownitem') && item.nodeName === 'LI' && list.includes('dropdownlist')){

                    //Get Confirm remove
                    let confirmRemove = confirm("Deseja remover ?");

                    //Check confirm
                    if(confirmRemove){

                        //Get Dropdown Id
                        let dropdownId = item.getAttribute('id');

                        //Get Children
                        let elChildrens = [...item.children];

                        //Get Dropdown List
                        let dropdownList = elChildrens.find(valchildren => valchildren.nodeName === 'UL');

                        //Get Children from Dropdown List
                        let dropdownlistChildren = [...dropdownList.children];

                        //console.log(dropdownlistChildren);

                        //Check dropdown list
                        if(dropdownlistChildren.length > 0){

                            //List All Items
                            let dropdownitemlist = this.menudropdown.filter(valitem => valitem.pageidrefer === dropdownId);

                            //Remove Items
                            dropdownitemlist.forEach((valitem) => {

                                //Get Index from Menu Dropdown List
                                let indexMenuDropdown = this.menudropdown.indexOf(valitem);

                                //Remove dropdown item from list
                                this.menudropdown.splice(indexMenuDropdown, 1);

                            });

                        }

                        //===> Remove Dropdown Item from NavMenu List

                        //Check Navmenu List
                        if(this.menunamelist.length > 0){

                            let pagesitem = [];

                            this.menunamelist.map((value) => {

                                //Search on Pages List Menu
                                value.pages.forEach((valpages, indexpages) => {

                                    //Get only Dropdown Items
                                    if(Array.isArray(valpages)){

                                        //console.log(valpages);
                                        //console.log(dropdownId);

                                        let menuvaluelist = valpages.filter(valdropdownitem => valdropdownitem.pageidrefer === dropdownId);

                                        //Check MenuFIleList
                                        if(menuvaluelist.length > 0){

                                            //Set a menudropdown data
                                            let dropdownData = {
                                                menuname: value.name,
                                                menuvalue: menuvaluelist
                                            };

                                            //Set Dropdown Data
                                            pagesitem.push(dropdownData);

                                            //Remove Pages Item
                                            value.pages.splice(indexpages, 1);

                                        }

                                    }

                               });


                            });

                            //console.log(pagesitem);

                            //Check Dropdown List
                            if(pagesitem.length > 0){

                                console.log(pagesitem[0]);

                                //Get Children from Navmenu List
                                let navmenu = [...document.querySelector(`.navmenu-${pagesitem[0].menuname}`).children];

                                //Get Element and Remove
                                let navmenuEl = navmenu.find(valitem => parseInt(valitem.getAttribute('data-pageid')) === parseInt(dropdownId));

                                //Remove Element from DOM
                                if(navmenuEl !== undefined){

                                    navmenuEl.remove();

                                }

                                //console.log(navmenuEl);

                            }

                        }

                        //Remove Element
                        item.remove();

                    }

                    return;
                    
                }

                return;

            },
            dataStructureResponse(responseObject, action){

                //Get Key and Value
                let entries = Object.entries(responseObject);

                //Response Value

                //Loop response conditional
                for(const [key, value] of entries){

                    switch(key)
                    {

                        case 'attListData':

                            //Set Boolean Value
                            this.sendform = true;

                            //Set New Att Datalist
                            switch(action){

                                //NavMenu
                                case 'navmenulist':

                                    //Set Data
                                    this.menunamelist = value;

                                    //Set List for Menu
                                    this.addMenuPagesList();

                                    //Show Fieldset Menu List
                                    if(document.querySelector('.fieldsetcontentmenulist').classList.contains('d-none')){

                                        document.querySelector('.fieldsetcontentmenulist').classList.remove('d-none')

                                    }

                                    //Clean Variable
                                    this.navmenuname = '';

                                    //Enable BTN
                                    this.disabled = false;

                                break;

                                //Post Create is Default
                                default:

                                    //Redirect after Update
                                    if(this.formaction === 'update'){

                                        return window.location.replace(this.baseurl + "/admin/website/navigation");

                                    }

                                    //Set Data
                                    this.alldata = value;

                                    //Clean Variable
                                    this.navmenuname = '';
                                    this.menudropdown = [];

                                    //Set List for Menu 
                                    this.addMenuPagesList();

                                    //Get All fieldsetcontent
                                    let fieldsetcontentall = [...document.querySelectorAll('.fieldsetcontent')];

                                    //Show Fieldset Menu List
                                    this.hideContainers(fieldsetcontentall);

                                    //Set Text Content for Btn List
                                    document.querySelector('.btnmenulist').textContent = "Show";

                                    //Clean Dropdown List Base
                                    let dropdwonlistbase = [...document.querySelector('.dropdwonlistbase').children];

                                    //Check Children
                                    if(dropdwonlistbase.length > 0){

                                        dropdwonlistbase.forEach((value) => {

                                            //Remove Elements
                                            value.remove();

                                        });

                                    }

                                    //All Menu List
                                    let allnavmenulist = [...document.querySelectorAll('.navmenu')];

                                    allnavmenulist.forEach((valmenu) => {

                                        let navmenu = [...valmenu.children];

                                        if(navmenu.length > 0){

                                            navmenu.forEach((valnavitem) => {

                                                valnavitem.remove();

                                            });

                                        }

                                    });

                                    //Enable BTN
                                    this.disabled = false;
                                
                                break;

                            }
                            
                
                        break;

                        case 'successMessage':
                        case 'errorMessage':
                            
                            //Add active Class
                            this.$refs.responsebasemessage.classList.add(this.activeclass);
                            this.$refs.responsebasemessage.classList.add(key.toLowerCase());

                            //Set Messages List
                            value.forEach((valmessage) => {

                                //Element for append
                                let li = `<li class="list-group item my-1">${valmessage}</li>`;

                                //Append Element
                                $(li).appendTo(this.$refs.responsebasemessage.children);

                            });
                            

                        break;

                    }

                }

                //Remove Base Response Message
                this.removeResponseMessages();

                return;

            },
            hideContainers(containers){

                containers.forEach((value) => {

                    //Hide all
                    if(!value.classList.contains('d-none')){

                        value.classList.add('d-none');

                    }

                });

            },
            removeResponseMessages(time = 5000){

                setTimeout(function(){

                    //Remove active class
                    document.querySelector('.responsebasemessage').classList.remove('d-flex');
                    document.querySelector('.responsebasemessage').classList.remove('successmessage');
                    document.querySelector('.responsebasemessage').classList.remove('errormessage');

                    //Remove children elements
                    let ul = document.querySelector('.responsebasemessage').children;

                    [...ul[0].children].forEach((valli) => {

                        //Remove Elements
                        valli.remove();

                    });

                }, time);

            },
            sendDataAction(formaction, action){

                //Url Action
                let urlmethod = '';

                //Choose Route Action
                switch(action){

                    //NavMenu
                    case 'navmenulist':

                        //Get Route by Http Method
                        switch(formaction){

                            case 'insert':
                                urlmethod = this.navmenucreate;
                            break;

                        }

                    break;

                    //NavMenu Content
                    case 'navmenulistcontent':

                        //Get Route by Http Method
                        switch(formaction){

                            case 'update':
                                urlmethod = this.navmenuupdate;
                            break;

                        }

                    break;

                }

                return urlmethod;

            },
            sendData(formaction, action, data = null, element = null){

                //Disabled BTN
                this.disabled = true;

                //Active Loading
                document.querySelector('.loadingbase').classList.add('d-flex');

                //Structure Data Form
                let dataForm = {};

                //List of the Actions Create
                let actionroute = ['navmenulist'];

                //Check Action
                if(actionroute.includes(action) 
                && data !== null
                && element !== null){

                    //Check Data - inputValidationType 4 is default
                    let inputDataCheck = this.inputValidationMethod(4, data);

                    //Set Id Error Message
                    this.listidinputs.push(element);
                    
                    //Check Input Validation
                    if(inputDataCheck){

                        //Clean Variable
                        this.listidinputs = [];

                        //Set Data formcondtional
                        dataForm.formaction = formaction;
                        
                        //Check storiescompany action
                        dataForm.name = data.includes(',') ? data.split(",") : data;

                    }else{

                        //Set Unique Values
                        this.listidinputs = [...new Set(this.listidinputs)];

                        //Generate Error Message
                        this.dynamicErrorMessageGenerate(this.listidinputs);

                        //Clean Variable
                        this.listidinputs = [];

                    }

                }

                //Set Route
                let method;
                let urlmethod; 

                switch(formaction)
                {

                    //Insert
                    case 'insert':

                        method = 'POST';
                        urlmethod = this.sendDataAction(formaction, action);

                        //Set Data for correspondent action
                        switch(action)
                        {

                            //Navmenulist
                            case 'navmenulistcontent':

                                //Check Menu List
                                if(Object.values(this.menunamelist).length > 0){

                                    //Set Data formcondtional
                                    dataForm.formaction = 'insert';
                                    dataForm.menucontent = this.menunamelist.filter(valmenulist => valmenulist.pages.length > 0);

                                }

                            break;

                        }

                    break;

                    //Update
                    case 'update':

                        method = 'PUT';
                        urlmethod = this.sendDataAction(formaction, action);

                        //Set Data for correspondent action
                        switch(action)
                        {

                            //Navmenulist
                            case 'navmenulistcontent':

                                //Check Menu List
                                if(Object.values(this.menunamelist).length > 0){

                                    //Set Data formcondtional
                                    dataForm.formaction = 'update';
                                    dataForm.menucontent = this.menunamelist.filter(valmenulist => valmenulist.pages.length > 0);

                                }

                            break;

                        }

                    break;

                    //Delete
                    case 'delete':

                        method = 'DELETE';
                        urlmethod = this.navmenudelete;

                        //Set Data formcondtional
                        dataForm.formaction = formaction;
                        dataForm = data;

                    break;

                    //Active    
                    case 'active':

                        method = 'PUT';
                        urlmethod = this.navmenuactive;

                        //Set Data formcondtional
                        dataForm.formaction = formaction;
                        dataForm = data;

                    break;

                    //Soft Delete
                    case 'softdelete':

                        method = 'PUT';
                        urlmethod = this.navmenusoftdelete;

                        //Set Data formcondtional
                        dataForm.formaction = formaction;
                        dataForm = data;

                    break;

                    //Restore Soft Delete
                    case 'restoresoftdelete':

                        method = 'PUT';
                        urlmethod = this.navmenurestore;

                        //Set Data formcondtional
                        dataForm.formaction = formaction;
                        dataForm = data;

                    break;

                }

                //console.log([method, urlmethod]);
                //console.log(Object.keys(dataForm));
                console.log(dataForm);
                //return;

                //Check Data Form
                if(parseInt(Object.keys(dataForm).length) > 0){

                    //Check Formaction
                    switch(formaction){

                        //Insert or Updated
                        case 'insert':
                        case 'update':
                            
                            if(parseInt(dataForm.menucontent.length) > 0){

                                //Send Data
                                let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);

                                //Check Response
                                response.then((value) => {

                                    //Desactive Loading
                                    document.querySelector('.loadingbase').classList.remove('d-flex');

                                    //Generate a Response
                                    return this.dataStructureResponse(value, action);

                                }).catch((error) => {

                                    //Show Error Message
                                    alert('Ocorreu um Erro e em breve iremos o resolver, agradecemos pela compreensão');

                                    //Desactive Loading
                                    document.querySelector('.loadingbase').classList.remove('d-flex');

                                    //Enabled BTN
                                    this.disabled = false;

                                    throw new Error(error);

                                });

                            }else{

                                //Send Message
                                alert('Por favor apenas enviar dados válidos');

                                //Desactive Loading
                                document.querySelector('.loadingbase').classList.remove('d-flex');

                                //Enabled BTN
                                this.disabled = false;

                            }   
                        
                        break;

                        //Active
                        case 'active':

                            //Send Data
                            let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);

                            //Check Response
                            response.then((value) => {

                                //Desactive Loading
                                document.querySelector('.loadingbase').classList.remove('d-flex');

                                //Generate a Response
                                return this.dataStructureResponse(value, action);

                            }).catch((error) => {

                                //Show Error Message
                                alert('Ocorreu um Erro e em breve iremos o resolver, agradecemos pela compreensão');

                                //Desactive Loading
                                document.querySelector('.loadingbase').classList.remove('d-flex');

                                //Enabled BTN
                                this.disabled = false;

                                throw new Error(error);

                            });

                        break;    

                    }
                                
                }else{

                    //Send Message
                    alert('Por favor apenas enviar dados válidos');

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enabled BTN
                    this.disabled = false;

                }

                return;

            }
            
        },
        computed:{

            computedAllData(){

                return this.alldata;

            },
            computedMenuList(){

                return this.menunamelist;

            },
            computedDropDownCount(){

                return this.dropdowncount;

            },
            computedMenuDropdown(){

                return this.menudropdown;

            }

        },
        watch:{

            computedAllData(){},
            computedMenuList(){},
            computedDropDownCount(){},
            computedMenuDropdown(){}

        },
        components:{

            listMessage: ListMessage,
            loading: Loading,
            tableElement:Table,
            backTo: BackTo,

        }


    }

</script>